import React from 'react';

import { ADMIN_PROFILE_SETUP } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { ProfileTemplateIcon } from '@Generic/icons';

const ProfileSetupPage = React.lazy(() => import('../../../pages/Admin/ProfileSetupPage'));

export default {
  label: 'admin-page.profile-setup.title',
  group: ADMIN,
  to: '/administration/profile-setup',
  route: ['/administration/profile-setup', `/administration/profile-setup/:tabId`],
  component: ProfileSetupPage,
  icon: <ProfileTemplateIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_PROFILE_SETUP,
  area: ADMIN_PROFILE_SETUP,
  hasNavBar: true,
};
